"use client";

import React from 'react';
import { FileQuestion } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { useRouter } from 'next/navigation';

const NotFound: React.FC = () => {
  const router = useRouter();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4">
      <FileQuestion className="w-16 h-16 text-yellow-500 mb-4" />
      <h1 className="text-2xl font-bold text-gray-800 mb-2">
        Página Não Encontrada
      </h1>
      <p className="text-gray-600 text-center mb-6 max-w-md">
        A página que você está procurando não existe ou foi movida.
      </p>
      <div className="flex gap-4">
        <Button
          onClick={() => router.push('/system')}
          variant="outline"
        >
          Voltar ao Início
        </Button>
        <Button
          onClick={() => router.back()}
          variant="default"
        >
          Voltar à Página Anterior
        </Button>
      </div>
    </div>
  );
};

export default NotFound; 